import Decimal from 'decimal.js';

import { Charges } from '@/v2/services/availability/types/api/parsedResponse';

interface Offer {
  charges: Charges;
}

const sum =
  (key: string) =>
  (...offers: Offer[]) => {
    return offers.reduce((result, offer) => {
      const d = Decimal.add(result, offer.charges[key as keyof Charges].amount);

      return d.toNumber();
    }, 0);
  };

const getTotalCharges = (baseOffer: Offer, ...offers: Offer[]): Charges => {
  return ['total', 'perTraveller'].reduce((obj, key) => {
    return {
      ...obj,
      [key]: {
        amount: sum(key)(baseOffer, ...offers),
        currency: baseOffer.charges[key as keyof Charges].currency,
      },
    };
  }, {}) as Charges;
};

export const getReturnOfferCharges = ({
  offer,
  selectedOption,
}: {
  offer: Offer;
  selectedOption: Offer;
}) => getTotalCharges(offer, selectedOption);

const getOfferCharges = ({
  offer,
  selectedInboundOption,
  selectedOutboundOption,
}: {
  offer: Offer;
  selectedInboundOption: Offer;
  selectedOutboundOption: Offer;
}) => getTotalCharges(offer, selectedInboundOption, selectedOutboundOption);

export default getOfferCharges;
